import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';
import Button from '../../../../components/Button';

export const PageTitle = styled.div`
    font-weight: bold;
    font-size: ${theme.font.size20};
    color: ${(props) => props.theme.black};
    padding: 0 32px 32px;
`;

export const SpacingAccordion = styled.div`
    height: 32px;
`;

export const ButtonContinueCustom = styled(Button)`
    &:disabled {
        border: 1px solid ${(props) => props.theme.disabledGrey};
    }
`;

export const SpacingTitle = styled.div`
    margin: 32px 0 0 0;
`;
